<form class="report-center-dialog" [formGroup]="formData" novalidate>
  <div matDialogTitle class="modal-header report-center-dialog__header">
    <div class="report-center-dialog__header-text">
      <h2>{{ data.title }}</h2>
      <small>{{ data.description }}</small>
    </div>
    <button mat-dialog-close aria-label="Close dialog" title="יציאה" class="btn btn-circle.btn-lg report-center-dialog__close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <mat-dialog-content *ngIf="formData" class="report-center-dialog__content">
    <section class="report-center-dialog__section">
      <div class="report-center-dialog__section-title">סינונים</div>

      <div class="report-center-dialog__grid">
        <ng-container *ngFor="let field of data.fields">
          <div class="report-center-dialog__field" [ngSwitch]="field.type">
            <mat-select-multiple-dropdown *ngSwitchCase="'multiSelect'"
              [keyProperty]="field.keyProperty"
              [titleProperty]="field.titleProperty"
              [listControl]="formData.controls[field.key]"
              [placeholder]="field.placeholder"
              [list]="servicesData[field.listKey]">
            </mat-select-multiple-dropdown>

            <div *ngSwitchCase="'select'" class="input-group mb-3">
              <label>{{ field.label }}</label>
              <mat-select class="form-control" [placeholder]="field.placeholder" [formControlName]="field.key">
                <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.title }}</mat-option>
              </mat-select>
            </div>

            <date-input-range *ngSwitchCase="'dateRange'"
              [placeHolderStart]="field.label || 'מתאריך'"
              [placeHolderEnd]="field.placeholder || 'עד תאריך'"
              [dateRangeCtrl]="formData.controls[field.key]">
            </date-input-range>

            <amount-input-range *ngSwitchCase="'amountRange'"
              [placeHolderMin]="field.label || 'מסכום'"
              [placeHolderMax]="field.placeholder || 'עד סכום'"
              [amountRangeCtrl]="formData.controls[field.key]">
            </amount-input-range>

            <auto-complete *ngSwitchCase="'autoComplete'"
              apply-enter
              [placeholder]="field.placeholder"
              [controllerName]="field.controllerName"
              [formGroupModel]="formData"
              [idControl]="formData.controls[field.idControlKey]"
              [nameControl]="formData.controls[field.nameControlKey]">
            </auto-complete>

            <div *ngSwitchCase="'checkbox'" class="input-group mb-3 report-center-dialog__checkbox-field">
              <label>{{ field.label }}</label>
              <mat-checkbox fxLayout="row" class="example-margin" [formControlName]="field.key"></mat-checkbox>
            </div>

            <div *ngSwitchCase="'text'" class="input-group mb-3">
              <label>{{ field.label }}</label>
              <input apply-enter type="text" class="form-control" [formControlName]="field.key" [placeholder]="field.placeholder">
            </div>

            <div *ngSwitchCase="'number'" class="input-group mb-3">
              <label>{{ field.label }}</label>
              <input apply-enter type="number" class="form-control" [formControlName]="field.key" [placeholder]="field.placeholder">
            </div>
          </div>
        </ng-container>
      </div>
    </section>

    <section class="report-center-dialog__section">
      <div class="report-center-dialog__section-head">
        <div class="report-center-dialog__section-title">עמודות לייצוא</div>
        <button type="button" class="btn btn-default" (click)="toggleAllColumns()">
          {{ isAllColumnsSelected() ? 'נקה הכל' : 'בחר הכל' }}
        </button>
      </div>

      <mat-selection-list *ngIf="data.columns?.length; else columnsLoading" [formControl]="columnsControl" multiple class="report-center-dialog__columns-list">
        <mat-list-option *ngFor="let column of data.columns" [value]="column.key">
          {{ column.title }}
        </mat-list-option>
      </mat-selection-list>

      <ng-template #columnsLoading>
        <div class="report-center-dialog__columns-loading">טוען עמודות מהשרת...</div>
      </ng-template>

      <div class="report-center-dialog__validation" *ngIf="columnsControl.touched && (!columnsControl.value || !columnsControl.value.length)">
        יש לבחור לפחות עמודה אחת.
      </div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer report-center-dialog__footer" align="end">
    <button mat-dialog-close type="button" class="btn btn-default navbar-btn">ביטול</button>
    <button apply-enter type="button" class="btn btn-primary navbar-btn" [disabled]="formData.invalid" (click)="exportExcel()">
      <i class="fa fa-file-excel-o"></i> הורד אקסל
    </button>
  </mat-dialog-actions>
</form>
